import { render, staticRenderFns } from "./SingleChild.vue?vue&type=template&id=31adb78d&"
import script from "./SingleChild.vue?vue&type=script&lang=js&"
export * from "./SingleChild.vue?vue&type=script&lang=js&"
import style0 from "./SingleChild.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports